import React, { useEffect, useState } from "react";
import { useFittingProduct } from "../../hooks/ProductHooks";
import Page from "../../layout/Page";
import GenericOverlay from "../../components/modal/GenericOverlay";
import "./style.scss";
import PageNotFoundFragment from "../../fragments/PageNotFoundFragment";
import { gtmSendViewItem } from "../../utils/GTMUtils";
import ProductPageInner2 from "./inner-v2";
import { productUrls } from "../../utils/ProductUtils";
import { Helmet } from "react-helmet";
import { usePathLang } from "../../hooks/LangHooks";
import { useProductCategories } from "../../hooks/ProductCategoryHooks";
import { toAbsoluteUrl } from "../../config/urls";

const ProductPage = props => {
  const { displayAsOverlay = false, match } = props;
  const { art_id: artId } = match.params;

  return (
    <PageWrapper displayAsOverlay={displayAsOverlay} key={artId}>
      <ProductPageContent {...props} key={artId} />
    </PageWrapper>
  );
};

const PageWrapper = ({ displayAsOverlay, children }) => {
  return displayAsOverlay ? (
    <GenericOverlay id="product-overlay" key="product-overlay">
      {children}
    </GenericOverlay>
  ) : (
    children
  );
};
const ProductPageContent = ({
  isPreview = false,
  displayAsOverlay = false,
  location,
  history,
  match
}) => {
  const pathLang = usePathLang();
  const { art_id: artId } = match.params;
  const product = useFittingProduct(artId);
  const categories = useProductCategories();
  //console.log("product:", product);
  //console.log("categories:", categories);
  const validProductUrls = productUrls(product, categories);
  //console.log("validProductUrls:", validProductUrls);
  const [redirectTo, setRedirectTo] = useState("");
  useEffect(() => {
    if (
      validProductUrls.length > 0 &&
      validProductUrls.indexOf(match.url) === -1
    ) {
      setRedirectTo((pathLang ? "/" + pathLang : "") + validProductUrls[0]);
    }
  }, [match.url, pathLang, validProductUrls]);

  useEffect(() => {
    if (redirectTo) {
      window.history.replaceState(null, "", redirectTo);
      //history.replace(_redirectTo); - causes rerender loop
      //return <Redirect to={_redirectTo} />; - causes re-routing so overlay will open
    }
  }, [redirectTo]);

  useEffect(() => {
    gtmSendViewItem(product, categories);
  }, [categories, product]);

  if (product.statusCode === 404) {
    return displayAsOverlay ? (
      <GenericOverlay id="product-overlay">
        <PageNotFoundFragment />
      </GenericOverlay>
    ) : (
      <Page
        title={""}
        name={"404"}
        key={"product-page" + artId}
        transition="simple"
      >
        <PageNotFoundFragment />
      </Page>
    );
  }

  return (
    <>
      <Helmet>
        <link
          rel="canonical"
          href={toAbsoluteUrl(validProductUrls[0], pathLang)}
        />
      </Helmet>
      {!!redirectTo && (
        <Helmet>
          <meta name="prerender-status-code" content={"302"} />
          <meta
            name="prerender-header"
            content={
              "Location: " +
              window.location.origin.toString() +
              encodeURI(redirectTo)
            }
          />
        </Helmet>
      )}

      <ProductPageInner2
        product={product}
        location={location}
        history={history}
        match={match}
        displayAsOverlay={displayAsOverlay}
        isPreview={isPreview}
      />
    </>
  );
};

export default ProductPage;
